<div class="container" fxLayout="row" >
  <div fxLayout="column" class="imageColumn">
    <a href="{{item.url}}"><img src="{{item.imageUrl}}" /></a>
  </div>
  <div fxLayout="column" class="descriptionColumn">
    <h2><a href="{{item.url}}">{{item.title}}</a></h2>
    <div class="description" [innerHtml]="item.description"></div>
  </div>
</div>
